import { useCallback } from 'react';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { allTasksExcludingJSMBusinessTasks as allTasks } from '../../common/constants.tsx';
import type { TaskList } from '../../common/types.tsx';
import { messages } from './messages.tsx';

export const useConvertToRootTaskList = (): ((taskItems: string[]) => TaskList | undefined) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(taskItems) => {
			const filteredTaskItems = taskItems.filter((task) => allTasks.includes(task));

			if (filteredTaskItems.length === 0) {
				fireOperationalAnalytics(createAnalyticsEvent({}), 'quickstartTaskList mismatched', {
					taskItems,
				});
				return undefined;
			}
			return {
				root: {
					title: messages.rootTitle,
					items: filteredTaskItems,
				},
			};
		},
		[createAnalyticsEvent],
	);
};
